import React from 'react';
import styles from './styles.module.css';

function PrimaryEmail({ record }) {
  return (
    <div className={styles.primaryEmailContainer}>
      <span className={styles.primaryEmailLabel}>Primary Email</span>
      <span className={styles.primaryEmailValue}>
        {record?.primaryEmail || 'N/A'}
      </span>
    </div>
  );
}

export default PrimaryEmail;
